<template>
  <AppModal id="speed-import-timesheets" :close-on-backdrop="closeOnBackdrop">

    <template #title>
      <h3 class="text-center mb-5">{{$t($getConst.pages.excel.speed_import) | capitalize}}</h3>
    </template>

    <template #content>
      <div class="mx-auto text-center">
        <!-- Step 1: select client -->
        <b-form-group id="speed-client-id" :label="$t($getConst.pages.client.client_name)" label-for="speed-client-name" class="mb-4">
          <multiselect v-if="clients" v-model.trim="client"
                       id="speed-client-name"
                       :options="clients"
                       track-by="id"
                       label="name"
                       :multiple="false" openDirection="bottom"
                       :searchable="true" :close-on-select="true"
                       :max-height="600" :show-no-results="false"
                       :disabled="isLoading"
          >
            <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
          </multiselect>
        </b-form-group>

        <!-- Step 2: select file (only once a client is picked) -->
        <input
          v-if="Object.values(client).length !== 0"
          type="file"
          name="speed-file"
          id="speed-file"
          class="input-file"
          :disabled="isLoading"
          @change="speedImport"
        />
        <label for="speed-file" v-if="Object.values(client).length !== 0">
          <i :class="[$getConst.icons.upload, 'mr-2']"/>
          <span v-if="!file">{{$t($getConst.pages.form.choose_file)}}</span>
          <span v-else>{{file.name}}</span>
        </label>
      </div>

      <b-list-group id="speed-success" v-if="imported" class="my-3">
        <b-list-group-item class="bg-light d-flex justify-content-between align-items-center font-weight-bold text-success">
          {{$t($getConst.pages.alerts.success_operation) | capitalize}}
        </b-list-group-item>
      </b-list-group>

      <b-progress v-if="isLoading" class="mx-auto w-75 mt-3" show-progress animated variant="secondary" height="3rem">
        <b-progress-bar class="font-weight-bold font-size-md" :value="uploadPercentage" :label="`${uploadPercentage}%`"/>
      </b-progress>
    </template>

  </AppModal>
</template>

<script>
  import AppModal from "../../../components/common/modals/AppModal";
  import {speedImportTimesheetsExcel} from "../../../api/vendorTimesheets.api";

  export default {
    name: "SpeedImportTimesheetsModal",
    components: {AppModal},
    props: {
      clients: false,
      scopeId: null
    },
    data() {
      return {
        file: null,
        uploadPercentage: 0,
        isLoading: false,
        imported: false,
        client: {},
        closeOnBackdrop: true
      }
    },
    methods: {
      speedImport(event) {
        this.file = event.target.files[0];
        this.imported = false;

        if (!this.file) {
          return;
        }

        this.closeOnBackdrop = false;
        this.isLoading = true;
        this.uploadPercentage = 0;

        speedImportTimesheetsExcel(
          this.scopeId || this.$store.getters['auth/scopeDefault'].id,
          this.file,
          (progressEvent) => {
            this.uploadPercentage = Math.round(100 * progressEvent.loaded / progressEvent.total);
          },
          (this.client) ? this.client.id : ""
        ).then(() => {
          this.uploadPercentage = 0;
          this.isLoading = false;
          this.closeOnBackdrop = true;
          this.imported = true;
          this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
          this.$emit("speedImportedTimesheets");
        }).catch((error) => {
          this.uploadPercentage = 0;
          this.isLoading = false;
          this.closeOnBackdrop = true;
          this.handleApiError(error);
        });
      },
      reset() {
        this.file = null;
        this.uploadPercentage = 0;
        this.isLoading = false;
        this.imported = false;
        this.client = {};
        this.closeOnBackdrop = true;
      }
    },
    mounted() {
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        if (modalId === "speed-import-timesheets") {
          this.reset();
        }
      })
    }
  }
</script>
